import React, { useState, useRef, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useConfig } from 'msp-integrations'
import {
  AlertBox,
  EventsEmitter,
  Events,
  Icons,
  Spinner,
  Button,
  Input
} from '../../../index'
import { PromoCodeProps } from './PromoCode.types'

const PromoCode = ({
  applyPromoCode,
  bonusDiscountLineItems = [],
  infoText,
  onCodeAdded = (hasChoiceOfBonusProducts: boolean) => {}
}: PromoCodeProps) => {
  const { formatMessage } = useIntl()
  const {
    theme: { font }
  } = useConfig()

  const alertBoxRef = useRef<typeof AlertBox>()
  const [alertMessage, setAlertMessage] = useState<string>('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [promoCode, setPromoCode] = useState('')
  const [couponAdded, setCouponAdded] = useState(null)

  useEffect(() => {
    if (couponAdded) {
      let hasChoiceOfBonusProducts = false
      bonusDiscountLineItems.forEach((bonusDiscountLineItem: any) => {
        if (bonusDiscountLineItem.couponCode === couponAdded) {
          hasChoiceOfBonusProducts = true
          EventsEmitter.dispatch(
            Events.OPEN_CHOICE_OF_BONUS_PRODUCTS_MODAL,
            bonusDiscountLineItem
          )
        }
      })

      setCouponAdded(null)
      onCodeAdded(hasChoiceOfBonusProducts)
    }
  }, [bonusDiscountLineItems, couponAdded])

  const submitForm = async (promoCode: string) => {
    setIsSubmitting(true)
    try {
      await applyPromoCode(promoCode)
      // @ts-ignore
      setCouponAdded(promoCode)
    } catch (e) {
      setAlertMessage(
        formatMessage({
          defaultMessage:
            'Something went wrong while adding the coupon. Please check if the coupon is valid.',
          id: 'msp.promotion.error'
        })
      )
      // @ts-ignore
      alertBoxRef?.current?.showAlert()
      setPromoCode('')
    }
    setIsSubmitting(false)
    setPromoCode('')
  }

  return (
    <>
      <AlertBox
        ref={alertBoxRef}
        type={'error'}
        title={alertMessage}
        autoCloseTime={4000}
        closeButtonIcon={<Icons iconName='Close' size='base' />}
      />

      <Input
        id={'promoCode'}
        onChange={(e) => setPromoCode(e.target.value)}
        value={promoCode}
        isDisabled={isSubmitting}
        type='text'
        labelText={formatMessage({
          id: 'msp.cart.promo.code.input.label',
          defaultMessage: 'Promotional code'
        })}
      />
      <Button
        type='primary'
        variant='outline'
        className={'mb-6 mt-6 w-full'}
        onClick={() => {
          submitForm(promoCode)
        }}
        iconName={!isSubmitting ? 'ArrowRight' : ''}
        iconPosition='right'
        isDisabled={isSubmitting || !promoCode}
        isLoading={isSubmitting}
        isSubmit
        loadingContent={<Spinner size='lg' />}
      >
        {formatMessage({
          defaultMessage: 'Redeem',
          id: 'msp.cart.promo.code.submit.label'
        })}
      </Button>
      {infoText && (
        <span className='font-Roboto text-14 tracking-0'>{infoText}</span>
      )}
    </>
  )
}

export default PromoCode
